document.addEventListener('DOMContentLoaded', function() {
  let similarSlider = new Swiper('.similar-games-list', {
    loop: true,
    autoplay: false,
    slidesPerView: 6,
    speed: 700,
    grabCursor: true,
    mousewheel: true,
    keyboardControl:true,
    navigation:{
      nextEl:".similar-right",
      prevEl:".similar-left"
    }
  })

});
